//Reference: EN114 (Modified) 

/*  
    Added a new field 'ID_STRUCTURE_ORGANIZATIVE' which doesn't belong to the original EN114.
    The reason is to replicate an optimized backend that will return this field whose value will 
    contains all Structures related to a label. This relationship belongs to EN115
*/


import { Mappeable } from './mappeable.model';
import moment from 'moment';
import * as _ from 'lodash';


export class Label extends Mappeable {

    idTagPk: number;
    txtName: string;
    txtDescription: string;
    nmrUses: number;
    dateLastUse: string;
    mrkActive: boolean;
    globalTag: boolean;
    dateInsert: string;
    dateUpdate: string;
    userInsert: string;
    userUpdate: string;
    orgStructures: any;
    languageId: any;
    translations: any[];

    constructor(o) {
        super(o);
        this.dateInsert = moment(this.dateInsert, "YYYY-MM-DD").format("YYYY-MM-DD");
        this.dateUpdate = moment(this.dateUpdate, "YYYY-MM-DD").format("YYYY-MM-DD");
        this.dateLastUse = moment(this.dateLastUse, "YYYY-MM-DD").format("YYYY-MM-DD");
        this.nmrUses = this.nmrUses ??  0 
        this.mrkActive = this.mrkActive ??  false 
        this.orgStructures = this.orgStructures ??  [] 
        this.translations = this.translations ??  [] 
    }

    public mapToBack() {
        return {
            txtName: this.txtName,
            txtDescription: this.txtDescription,
            orgStructures: this.orgStructures,
            translations: this.translations,
            languageId: this.languageId,
            mrkActive: this.mrkActive
        }
    }


}